module.exports = __webpack_public_path__ + "dist/img/explain2.d22c121e.png";